import get from 'lodash/get';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';

interface IProps {
  params?: Types.IApi.List.Params;
}

const List = ({
  params,
}: IProps): [string[], () => Promise<Types.IQuery.List>] => [
  ['result', 'list', JSON.stringify(params)],
  async () => {
    const { data } = await Api.List(params);

    const items = (get(data, 'data.items') || []).map(Mappers.Result);
    const meta = Mappers.Meta(get(data, 'data.meta'));
    const rawSubjects = get(data, 'data.subjects') || get(data, 'data.meta.subjects') || [];
    const subjects = rawSubjects.map((s: any) => ({
      id: s.id || '',
      name: s.name || '',
      maxScore: s.max_score ?? s.maxScore ?? 0,
    }));

    return {
      items,
      meta: {
        ...meta,
        subjects: subjects.length > 0 ? subjects : meta.subjects,
      },
      subjects: subjects.length > 0 ? subjects : meta.subjects,
    };
  },
];

export default List;
